<template>
  <div>
    <el-image
      v-for="(item,index) in list"
      :key="index"
      style="width: 50px;margin:0 3px 3px 0"
      :src="item"
      :preview-src-list="list">
    </el-image>
  </div>
</template>

<script>
export default {
  name: 'ImageList',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style>

</style>
